import { BRANCH_LEN, ENTRY, RING, YARD, branchCell, homeCell, isBranch, isHome } from "./types.js";
/** The last shared-ring cell a colour visits before entering its home run. */
export const pivot = (color) => (ENTRY[color] + RING - 1) % RING;
/** Progress from a colour's entry, used for bot evaluation and UI ordering. */
export function progress(color, cell) {
    if (cell === YARD)
        return -1;
    if (isHome(cell))
        return RING + BRANCH_LEN;
    if (isBranch(cell))
        return RING + (cell - branchCell(color, 0));
    return (cell - ENTRY[color] + RING) % RING;
}
/** Returns every traversed cell, excluding origin, or null for a Home overshoot. */
export function walk(color, from, steps) {
    const path = [];
    let cell = from;
    for (let step = 0; step < steps; step += 1) {
        if (isHome(cell))
            return null;
        if (isBranch(cell)) {
            const branchIndex = cell - branchCell(color, 0);
            cell = branchIndex + 1 >= BRANCH_LEN ? homeCell(color) : branchCell(color, branchIndex + 1);
        }
        else if (cell === pivot(color)) {
            cell = branchCell(color, 0);
        }
        else {
            cell = (cell + 1) % RING;
        }
        path.push(cell);
    }
    return path;
}
